/* Stylesheet */

.main_menu {
  position: absolute;
  --min-width: 352px;
  --background: var(--ion-gradient-dark);
  border-radius: 0px 0px 120px 0px;
  z-index: 100;

  .content_container {
    --background: transparent;
  }
}
